import React, { useState, useReducer, useEffect, useContext } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import { makeStyles } from "@material-ui/styles";
import { Paper, Typography } from "@material-ui/core";
import { formatMoney, createPercentageBar, createEvenlySpacedArray } from '../helpers/constants';
import SVGComponent from "./SVGComponent";



export default function ColorBarLegend(props) {

  const state = useContext(AppContext);
  const s = state.strings;
  const typeId = state.ui.statisticsType;

  const { textLeft, textMid, textRight } = props;
  const useStyles = makeStyles((theme) => ({
    root: {
      height: 330,
      width: 16
    }
  }));

  const classes = useStyles();

  const barValueArray = () => {
    let count = 80;
    let series = [];
    let step = 6;
    let width = 5;
    for (let i = 0; i < count; i++) {
      series.push({ 's': i * step, 'l': width });
    }
    let statsValues = getStatsValues();
    let y = createEvenlySpacedArray(statsValues[0], statsValues[2], count);

    let data = series.map((value, index) => [value, y[index]]);

    return data;
  }

  const getStatsValues = () => state.ui.textOverlay[typeId] ? state.ui.textOverlay[typeId].values : state.ui.textOverlay['default'].values;
  const getStatsColors = () => state.ui.textOverlay[typeId] ? state.ui.textOverlay[typeId].colors : state.ui.textOverlay['default'].colors;
  const getStatsLabels = () => state.ui.textOverlay[typeId] ? state.ui.textOverlay[typeId].labels : state.ui.textOverlay['default'].labels;
  const getLabel = (index) => {
    return s.kiDetector[getStatsLabels()[index]];
  };
  const getLabelValue = (index) => {
    return getStatsValues()[index];
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: 340 }}>
      <SVGComponent width={340} height={16} svgString={createPercentageBar(340, 16, getStatsColors(), getStatsValues(), barValueArray())}></SVGComponent>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height:18 }}>
        <Typography variant='body1'>{getLabelValue(0)}</Typography>
        <Typography variant='body1'>{getLabelValue(1)}</Typography>
        <Typography variant='body1' >{getLabelValue(2)}</Typography>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom:2 }}>
        <Typography variant='body2' color="secondary">{getLabel(0)}</Typography>
        <Typography variant='body2' color="secondary">{getLabel(1)}</Typography>
        <Typography variant='body2' color="secondary">{getLabel(2)}</Typography>
      </div>
    </div>
  );
}
